import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useMetadataQuery } from "@/entities/form-metadata";
import { createUrlBuilder } from "./url-builder";
import styles from "./AdvancedSearchLink.module.scss";

export interface AdvancedSearchLinkProps {
    label?: string;
    locale?: string; // TODO?: locale prop for future use
}

export const AdvancedSearchLink = ({ label, locale }: AdvancedSearchLinkProps) => {
    const { t } = useTranslation();
    const { data: formMetadata } = useMetadataQuery();

    const handleClick = () => {
        const { contentType, id } = formMetadata;
        const urlBuilder = createUrlBuilder(locale);
        const href = urlBuilder.buildAdvancedSearchUrl({ contentType, id });

        window.open(href, "_self");
    };

    return (
        <button
            type="button"
            role="link"
            data-testid="toggle-classic-search-button"
            onClick={handleClick}
            className={classNames("link icon iconSettings", styles.mr12)}
        >
            {label ?? t("showAdvanced")}
        </button>
    );
};
